import { useMutation } from "@tanstack/react-query";
import {
  createFileRoute,
  useNavigate,
} from "@tanstack/react-router";

import { useTRPC } from "@/infrastructure/trpc/react";
import { AgentEditor } from "@/speech-agent/components/agent-editor";

const NEW_AGENT_TEMPLATE = `---
id: my-agent
name: Nový agent
language: cs-CZ
voice_name: marin
voice_type: openai
voice_rate: "1.0"
turn_detection_silence_ms: 800
fields:
  - { key: topic, label: "Téma", type: long_text, required: true }
---

## Instrukce pro agenta

Popiš, co má agent dělat, jak vést rozhovor, kdy zavolat nástroj end_conversation.

## Šablona výstupu

# Nadpis zápisu

**Datum:** ...
**Účastníci:** ...

## Kontext

{volný text}
`;

export const Route = createFileRoute(
  "/app/speech-agent/agents/new"
)({
  component: NewAgentPage,
});

function NewAgentPage() {
  const trpc = useTRPC();
  const navigate = useNavigate();
  const createAgent = useMutation(
    trpc.speechAgent.agents.create.mutationOptions({
      onSuccess: (created) => {
        void navigate({
          to: "/app/speech-agent/agents/$slug",
          params: { slug: created.slug },
        });
      },
    })
  );

  return (
    <AgentEditor
      title="Nový agent"
      initialMd={NEW_AGENT_TEMPLATE}
      isSaving={createAgent.isPending}
      onSave={(rawMd) => {
        createAgent.mutate({ rawMd });
      }}
      onCancel={() => {
        void navigate({ to: "/app/speech-agent/agents" });
      }}
      errorMessage={createAgent.error?.message}
    />
  );
}
